import tippy from "tippy.js";
export default class Tooltips {
    constructor() {
        this.tooltips = document.querySelectorAll('[data-tooltip-content]');
        this.init();
    }
    init() {
        this.tooltips.forEach((tooltip) => {
            tippy(tooltip, {
                content: tooltip.getAttribute('data-tooltip-content') || '',
                arrow: true,
                animation: null,
            });
        });
    }
}
